import { render, staticRenderFns } from "./ProductGeneral.vue?vue&type=template&id=30ff2e17&scoped=true&lang=pug&"
import script from "./ProductGeneral.vue?vue&type=script&lang=js&"
export * from "./ProductGeneral.vue?vue&type=script&lang=js&"
import style0 from "./ProductGeneral.vue?vue&type=style&index=0&id=30ff2e17&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ff2e17",
  null
  
)

export default component.exports